export default "__VITE_ASSET__D272jr3P__"